import axios from '../axios';

export default {
  getTempCodeMail () {
    return new Promise((resolve, reject) => {
      axios.get('/temp-code-mail')
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  addTempCodeMail (mail) {
    return new Promise((resolve, reject) => {
      axios.post('/temp-code-mail', {
        mail: mail,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
  deleteTempCodeMail (mailId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/temp-code-mail/${mailId}`)
        .then((response) => {
          resolve(response);
        })
        .catch(e => reject(e));
    });
  },
};
